import {useTranslation} from 'react-i18next';

import {Box, Typography} from '@mui/material';

import {WorkforceCulturalPillarCard} from './WorkforceCulturalPillarCard';
import {WorkforceProfileCulturalFitPillarScore} from '../../types/WorkforceProfileTypes';

export interface Props {
  pillars: WorkforceProfileCulturalFitPillarScore[];
}

export const WorkforceCulturalPillarsGrid = ({pillars}: Props) => {
  const {t} = useTranslation('translation', {keyPrefix: 'workforceProfilesPage.detail.culturalFitAnalysis'});

  if (pillars.length === 0) {
    return null;
  }

  return (
    <Box sx={{mb: 2.5}}>
      <Typography
        sx={{
          fontSize: 11,
          fontWeight: 500,
          color: 'text.secondary',
          letterSpacing: '0.06em',
          textTransform: 'uppercase',
          mb: 1.5,
        }}
      >
        {t('pillarScores')}
      </Typography>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
          gap: 1.25,
        }}
      >
        {pillars.map((pillar) => (
          <WorkforceCulturalPillarCard key={pillar.title.en} pillar={pillar} />
        ))}
      </Box>
    </Box>
  );
};
